/* eslint-disable @typescript-eslint/no-explicit-any */
type StyleProps = Record<string, any>;

interface Props {
  [key: string]: any;
  styles?: StyleProps;
}

type DynamicPropsFunction = (props: Props) => Partial<Props>;

interface Config {
  intents?: Record<string, Partial<Props>>;
  [key: string]: any;
}

const mergeProperties = (prevProps: Props, props: Partial<Props>): Props => {
  const newProps = { ...prevProps };

  for (const [key, item] of Object.entries(props)) {
    if (key === 'styles' && newProps.styles) {
      newProps.styles = { ...item, ...newProps.styles };
    } else if (key === 'classNames' && newProps.classNames) {
      newProps.classNames = Object.entries(newProps.classNames).reduce(
        (acc, [classKey, value]) => {
          return {
            ...acc,
            [classKey]: item[classKey] ? `${item[classKey]} ${value}` : value
          };
        },
        { ...item }
      );
    } else if (!prevProps[key]) {
      newProps[key] = item;
    }
  }

  return newProps;
};

const merge = (
  prevProps: Props,
  {
    dynamic,
    ...otherProps
  }: { dynamic?: DynamicPropsFunction; [key: string]: any }
): Props => {
  let newProps = { ...prevProps };

  if (typeof dynamic === 'function') {
    newProps = mergeProperties(newProps, dynamic(newProps));
  }

  newProps = mergeProperties(newProps, otherProps);

  return newProps;
};

export const propsMerge = (props: Props, config?: Config): Props => {
  if (!config) {
    return props || {};
  }

  const { intents, ...rootProps } = config;

  let newProps = { ...props };

  const intent = intents?.[props.intent];
  if (intent) {
    newProps = merge(newProps, intent);
  }

  newProps = merge(newProps, rootProps);

  return newProps;
};
